import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

import { rhythm } from '../utils/typography';

type ListProps = {
  align?: string;
};

const List = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: ${({ align }: ListProps) => align || 'flex-start'};
  margin: 0;
  margin-top: ${rhythm(1)};
  margin-bottom: ${rhythm(1)};
`;

const Item = styled.li`
  margin: 0 ${rhythm(0.5)} ${rhythm(0.5)};

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

const StyledBadge = styled(Link)`
  display: block;
  background: linear-gradient(45deg, #fe6b8b 30%, #ff8e53 90%);
  border-radius: 3px;
  border: 0;
  color: white;
  padding: ${rhythm(0.5)};
  box-shadow: 0 3px 5px 2px rgba(255, 105, 135, 0.3);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 10px 1px rgba(255, 105, 135, 0.27);
  }
`;

type BadgeProps = {
  to?: string;
  children?: React.ReactNode;
};

const Badge: React.FC<BadgeProps> = ({ to, children }) => {
  return <StyledBadge to={to}>{children}</StyledBadge>;
};

export default Badge;

type BadgeListProps = {
  data: {
    to: string;
    text: string;
  }[];
  align?: string;
};

export const BadgeList: React.FC<BadgeListProps> = ({ data, align }) => {
  return (
    <List align={align}>
      {data.map(({ text, to }) => (
        <Item key={text}>
          <Badge to={to}>{text}</Badge>
        </Item>
      ))}
    </List>
  );
};
